import * as React from "react";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import { COLORS } from "../../../Theme";

type EscalationToggleProps = {
  value: boolean;
  onChange: (checked: boolean) => void;
};

export default function EscalationToggle({ value, onChange }: EscalationToggleProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Stack marginBottom={2} padding={1} border={`1px solid ${value ? "#f58442" : COLORS.PRIMARY}`} borderRadius={4}>
      <FormControl component="fieldset" variant="standard">
        <FormControlLabel
          control={<Switch checked={value} onChange={handleChange} color="warning" />}
          label={value ? "Customer Escalated" : "Escalate Customer"}
        />
        {value ? (
          <FormHelperText>
            Customer will no longer appear in the queue. A CRM Case should be manually created for this customer.
          </FormHelperText>
        ) : (
          <FormHelperText>
            Enabling this will escalate the customer and remove from the queue
          </FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
}
